<div class="modal-content">
  <div class="text-right">
    <mat-icon mat-dialog-close class="icon">close</mat-icon>
  </div>
  <div class="content">
    <h6 class="text-center">
      <strong> <i class="fa-solid fa-bell alrt"></i> </strong>
    </h6>
    <p class="message">
      Have You Uploaded the Request File ? Proceed To Confirm.
    </p>
  </div>
  <br />
  <div class="btn">
    <button
      class="btn btn-light hover-clear clear"
      mat-dialog-close
      [mat-dialog-close]="true"
    >
      <span> Yes</span>
    </button>
    <button
      class="btn btn-light hover-clear clear"
      mat-dialog-close
      [mat-dialog-close]="false"
    >
      <span> No</span>
    </button>
  </div>
</div>
